import { getTopic, WATCH_ONLY_TOPICS } from '@gogrov/shared'
import { BRIAN_TOPIC_IDS } from '@/lib/topicPhotos'

// Brian's glyphs are single-path SVGs filled with currentColor, so one file
// serves both the cream and the amber treatment: the colour comes from CSS.
const RAW = import.meta.glob('../../assets/topics/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>
const BY_STEM: Record<string, string> = {}
for (const [path, svg] of Object.entries(RAW)) {
  const stem = path.split('/').pop()!.replace(/^topic-/, '').replace(/\.svg$/, '')
  // Drop the file's own title and preview colour; the label sits beside it.
  BY_STEM[stem] = svg
    .replace(/<style>[\s\S]*?<\/style>/, '')
    .replace(/<title>[\s\S]*?<\/title>/, '')
    .replace(/\s(width|height)="\d+"/g, '')
    .replace(/role="img"/, 'aria-hidden="true" focusable="false"')
}

export function TopicGlyph({ topic, size = 22, tone = 'amber', className }: {
  topic: string | null | undefined
  size?: number
  tone?: 'amber' | 'cream'
  className?: string
}) {
  // Our taxonomy ids first; then a watch-only type (aviation) or one of
  // Brian's short ids (prosports), so his data draws without a lookup table.
  const t = getTopic(topic) ?? getTopic(topic ? BRIAN_TOPIC_IDS[topic] : null)
  const icon = t?.icon ?? WATCH_ONLY_TOPICS.find((w) => w.id === topic)?.icon ?? (topic && BY_STEM[topic] ? topic : null)
  const svg = icon ? BY_STEM[icon] : null
  if (!svg) return null
  return (
    <span
      className={`topic-glyph${tone === 'cream' ? ' topic-glyph--cream' : ''}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
